import Image from '@Components/Image';
import CreateInvoiceFlow from '@Components/PurchaseInvoiceCreation/CreateInvoiceFlow';
import { Carrier } from '@Components/PurchaseInvoiceCreation/types';
import Title from '@Components/Title';
import { Box } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CreatePurchaseInvoice = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [selectedCarrier, setSelectedCarrier] = useState<Carrier | null>(null);
  const [invoiceDate, setInvoiceDate] = useState<Dayjs | null>(dayjs());
  const [dueDate, setDueDate] = useState<Dayjs | null>(dayjs());
  const [taxation, setTaxation] = useState('');
  const [departmentCode, setDepartmentCode] = React.useState<string>('');
  const [locationId, setLocationId] = React.useState<string>('');

  // Stepper handlers
  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => {
    if (activeStep === 0) {
      navigate('/purchase-invoices');
      return;
    }
    setActiveStep(prev => prev - 1);
  };
  const handleReset = () => {
    setActiveStep(0);
    setSelectedCarrier(null);
    setDueDate(null);
    setInvoiceDate(null);
    setTaxation('');
    setDepartmentCode('');
    setLocationId('');
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        <Box
          onClick={() => {
            if (activeStep === 0) {
              navigate('/purchase-invoices');
            } else {
              setActiveStep(prev => prev - 1);
            }
          }}
          sx={{ zIndex: '1', cursor: 'pointer' }}
        >
          <Image src="/images/backbutton.svg" alt="Back Button" style={{ width: '1.5rem', marginTop: '0.2rem' }} />
        </Box>
        <Title title="Purchase Invoices" subTitle="View and create purchase invoices" />
      </Box>
      <Box sx={{ marginY: '2rem' }}>
        <Title title="Create Invoices" removeBorder removePadding titleClass="underline px_20-text" />
      </Box>

      <CreateInvoiceFlow
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        handleReset={handleReset}
        selectedCarrier={selectedCarrier}
        setSelectedCarrier={setSelectedCarrier}
        invoiceDate={invoiceDate}
        setInvoiceDate={setInvoiceDate}
        dueDate={dueDate}
        setDueDate={setDueDate}
        taxation={taxation}
        setTaxation={setTaxation}
        setActiveStep={setActiveStep}
        departmentCode={departmentCode}
        setDepartmentCode={setDepartmentCode}
        locationId={locationId}
        setLocationId={setLocationId}
      />
    </>
  );
};

export default CreatePurchaseInvoice;
